
import React from 'react';
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import process from "process";
window.process = process;

createRoot(document.getElementById("root")!).render(<App />);
